import * as path from 'path';
const basePath = '/';
const apiBase = '/api/v1';
const assetBasePath = path.join(basePath, 'assets');
const api = (dirname) => {
    return path.join(apiBase, `${dirname}.json`);
};
const image = (dirname) => {
    return path.join(assetBasePath, 'img', dirname);
};
const page = (userType, dirname = '') => {
    return path.join(basePath, userType, dirname);
};
const root = () => {
    return path.join(basePath);
};
export default {
    api,
    image,
    page,
    root,
};
